angular.module('picmonicng').directive('learnTrack', [
  '$state',
  '$filter',
  'PicmonicQueue',
  'UserService',
  'Tracks',
  function ($state, $filter, PicmonicQueue, UserService, Tracks) {
    return {
      restrict: 'A',
      scope: {
        target: '=learnTrack',
        learnMethod: '@',
      },
      controller: [
        '$modal',
        '$scope',
        'MarketOptionsConfig',
        '$cookies',
        'Tracks',
        '$state',
        '$filter',
        function ($modal, $scope, MarketOptionsConfig, $cookies, Tracks, $state, $filter) {
          $scope.showRegisterModal = function (card) {
            var lead = UserService.user.lead ? UserService.user.lead : $cookies.get('pls_user_lead');
            var market = MarketOptionsConfig.getMarketById(lead);
            send_ga('event', 'Pathways', 'No Account Modal');

            $modal.open({
              templateUrl: '/templates/modals/register-modal.html',
              windowClass: 'registration-cta-modal full-screen-modal',
              backdropClass: 'modal-body-reduced',
              controller: 'RegisterModalController',
              resolve: {
                card: function () {
                  return card;
                },
                market_id: function () {
                  return lead;
                },
                copy: function () {
                  return null;
                },
                redirect: function () {
                  return null;
                },
                extraParams: function () {
                  return null;
                },
              },
            });
          };
        },
      ],
      link: function (scope, element, attrs) {
        element.bind('click', function (e) {
          scope.$apply(function () {
            if (!UserService.user || !UserService.user.user_id) {
              scope.showRegisterModal(scope.target);
            } else {
              if (
                UserService.user.playlist_mode != 'track' ||
                UserService.user.current_track_id != scope.target.track_id
              ) {
                UserService.user.playlist_mode = 'track';
                UserService.user.current_track_id = scope.target.track_id;
                UserService.user.$update();
              }

              if (scope.learnMethod == 'quiz') {
                var track_slug = $filter('slugify')(scope.target.name) + '-' + scope.target.track_id;
                PicmonicQueue.goToQuiz(track_slug, 'track', scope.target.total_facts, scope.target.name);
              } else {
                Tracks.get({ track_id: scope.target.track_id, resource: 'picmonics' }, function (track) {
                  send_ga('event', 'Pathways', 'Start Learning');
                  PicmonicQueue.setAndPlay(
                    $filter('orderBy')(track.cards, ['viewed_flag', 'attempted_flag', 'mastered_flag', 'sort_order']),
                    null,
                    true,
                    track.track_id
                  );
                });
              }
            }
          });
        });
      },
    };
  },
]);
